import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWorksheet } from 'services/worksheet/selectors';
import get from 'lodash.get';
import keyBy from 'lodash.keyby';
import sortBy from 'lodash.sortby';

import { AppState } from 'services/types';
import {
    FertilizerWorksheetEntitySummary,
    WorksheetPageIndex,
    FertilizerWorksheetEventProduct
} from 'services/worksheet/types';
import { OwnProps } from './index';

const selectPageIndex = (
    state: AppState,
    props: OwnProps
): WorksheetPageIndex => props.pageIndex;

const selectFertilizerWorksheetProducts = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (fertilizerWorksheetState, index) =>
        sortBy<FertilizerWorksheetEventProduct>(
            get(fertilizerWorksheetState, [
                'pages',
                index,
                'fertilizerEventProducts'
            ]),
            'orderIndex'
        )
);

const selectFertilizerWorksheetEntitySummaries = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (worksheetState, index) =>
        get(worksheetState, [
            'pages',
            index,
            'entitySummaries'
        ]) as FertilizerWorksheetEntitySummary[]
);

const makeSelectFertilizerWorksheetProducts =
    (): typeof selectFertilizerWorksheetProducts =>
        selectFertilizerWorksheetProducts;

const selectFertilizerWorksheetProductsKeyedById = createDeepEqualSelector(
    selectFertilizerWorksheetProducts,
    (productsState) => keyBy(productsState, 'id')
);

export {
    selectPageIndex,
    selectFertilizerWorksheetProductsKeyedById,
    makeSelectFertilizerWorksheetProducts,
    selectFertilizerWorksheetProducts,
    selectFertilizerWorksheetEntitySummaries
};
